// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var FeedbackType = function (x) {
    return x;
};
var tsBridgeFeedbackType = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("FeedbackType")("__brandFeedbackType"));
    }
};
var writeFeedbackType = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showFeedbackType = Data_Show.showString;
var readFeedbackType = Simple_JSON.readString;
var ordFeedbackType = Data_Ord.ordString;
var newtypeFeedbackType = {
    Coercible0: function () {
        return undefined;
    }
};
var makeFeedbackType = FeedbackType;
var eqFeedbackType = Data_Eq.eqString;
export {
    FeedbackType,
    makeFeedbackType,
    unwrap,
    newtypeFeedbackType,
    eqFeedbackType,
    ordFeedbackType,
    showFeedbackType,
    readFeedbackType,
    writeFeedbackType,
    tsBridgeFeedbackType
};
//# sourceMappingURL=index.js.map
